import React from 'react';

import { Chart } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  registerables as registerablesJS,
} from 'chart.js';
ChartJS.register(...registerablesJS);
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

export const options = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    mode: 'index',
    intersect: false,
  },
  scales: {
    y: {
      beginAtZero: true,
      border: {
        display: false,
      },
      grid: {
        color: 'rgba(102, 112, 133, 0.14)',
        drawTicks: false,
      },
      ticks: {
        color: '#667085',
        padding: 10,
        callback: (value) =>
          new Intl.NumberFormat('vi-VN', {
            notation: 'compact',
            maximumFractionDigits: 1,
          }).format(value),
      },
    },
    x: {
      border: {
        display: false,
      },
      grid: {
        color: 'rgba(102, 112, 133, 0.08)',
        drawTicks: false,
      },
      ticks: {
        color: '#667085',
        maxRotation: 0,
        autoSkip: true,
        maxTicksLimit: 10,
        padding: 10,
      },
    },
  },
  plugins: {
    legend: {
      display: true,
      position: 'bottom',
      labels: {
        color: '#344054',
        boxWidth: 10,
        boxHeight: 10,
        usePointStyle: true,
        padding: 16,
      },
    },
    tooltip: {
      backgroundColor: '#172033',
      borderColor: 'rgba(255,255,255,0.12)',
      borderWidth: 1,
      padding: 12,
      titleColor: '#ffffff',
      bodyColor: '#ffffff',
      callbacks: {
        label: (context) =>
          `${context.dataset.label}: ${new Intl.NumberFormat('vi-VN').format(Number(context.raw || 0))}đ`,
      },
    },
  },
};

const RevenueChart = ({ data }) => {
  const dataChart = {
    labels: (data ?? [])?.map((o) => o?.date),
    datasets: [
      {
        type: 'line',
        label: 'Trước thuế',
        data: (data ?? [])?.map((o) => o?.total_money_before_vat ?? o?.total_money ?? 0),
        borderColor: '#2563eb',
        backgroundColor: 'rgba(37, 99, 235, 0.08)',
        borderWidth: 2,
        pointRadius: 2,
        pointHoverRadius: 5,
        pointBackgroundColor: '#ffffff',
        pointBorderColor: '#2563eb',
        pointBorderWidth: 2,
        fill: false,
        tension: 0.38,
      },
      {
        type: 'line',
        label: 'Sau thuế',
        data: (data ?? [])?.map((o) => o?.total_money_after_vat ?? o?.total_money ?? 0),
        borderColor: '#ed3237',
        backgroundColor: 'rgba(237, 50, 55, 0.10)',
        borderWidth: 2.5,
        pointRadius: 2.5,
        pointHoverRadius: 5,
        pointBackgroundColor: '#ffffff',
        pointBorderColor: '#ed3237',
        pointBorderWidth: 2,
        fill: true,
        tension: 0.38,
      },
    ],
  };
  return <Chart options={options} data={dataChart} />;
};

export default RevenueChart;
